import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, mergeMap } from 'rxjs';
import { catchError, map, retryWhen, switchMap } from 'rxjs/operators';
import { retryStrategy } from '@personal-area/global/http/services';
import { DepositBonusApiService } from '../services/deposit-bonus.api.service';
import {
  getDepositBonusAmount,
  getDepositBonusAmountFailure,
  getDepositBonusAmountSuccess,
  getDepositBonusAvailability,
  getDepositBonusAvailabilityFailure,
  getDepositBonusAvailabilitySuccess,
  getDepositBonusList,
  getDepositBonusListFailure,
  getDepositBonusListSuccess,
} from './actions';

@Injectable()
export class DepositBonusEffects {
  constructor(
    private _actions$: Actions,
    private _depositBonusApiService: DepositBonusApiService,
  ) {}

  getDepositBonusAvailability$ = createEffect(() =>
    this._actions$.pipe(
      ofType(getDepositBonusAvailability),
      switchMap(({ accountId, lang }) =>
        this._depositBonusApiService.getDepositBonusAvailability(accountId, lang).pipe(
          retryWhen(retryStrategy()),
          map(getDepositBonusAvailabilitySuccess),
          catchError((error) => of(getDepositBonusAvailabilityFailure(error))),
        )
      )
    )
  );

  getDepositBonusList$ = createEffect(() =>
    this._actions$.pipe(
      ofType(getDepositBonusList),
      mergeMap(({ accountId }) =>
        this._depositBonusApiService.getDepositBonusList(accountId).pipe(
          retryWhen(retryStrategy()),
          map((depositBonusList) => getDepositBonusListSuccess(accountId, depositBonusList)),
          catchError((error) => of(getDepositBonusListFailure(error))),
        )
      )
    )
  );

  getDepositBonusAmount$ = createEffect(() =>
    this._actions$.pipe(
      ofType(getDepositBonusAmount),
      switchMap(({ accountId, depositAmount, wasReceived }) =>
        this._depositBonusApiService
          .getDepositBonusAmount({ accountId, depositAmount, wasReceived })
          .pipe(
            retryWhen(retryStrategy()),
            map(getDepositBonusAmountSuccess),
            catchError((error) => of(getDepositBonusAmountFailure(error))),
          )
      )
    )
  );
}
